import React, {
  FC, useState, memo, useEffect, ReactElement,
} from 'react';
import cn from 'classnames';
import { createUseStyles } from 'react-jss';

interface ModalChooseProps {
  isOpened: boolean,
  message: string | ReactElement,
  onClose?: () => void,
  onClosed?: () => void,
  onConfirm?: () => void,
}

const ModalConfirmation: FC<ModalChooseProps> = (props) => {
  const {
    isOpened,
    message,
    onClose,
    onClosed,
    onConfirm,
  } = props;

  const classes = useStyles();

  const [isMounted, setMounted] = useState(false);
  const [isShown, setShown] = useState(false);

  useEffect(() => {
    if (isOpened && !isShown) {
      setMounted(true);
      setTimeout(() => {
        setShown(true);
      }, 10);
    }
    if (!isOpened && isShown) {
      setShown(false);
      setTimeout(() => {
        setMounted(false);
        onClosed?.();
      }, 300);
    }
  }, [isMounted, isOpened, isShown, onClosed]);

  return (
    <div
      className={cn(classes.container, { [classes.isShown]: isShown })}
    >
      <div className={classes.panel}>
        <div className={classes.header}>
          <div>Confirm Gift Card</div>
        </div>
        <div className={classes.content}>
          <div className={classes.message}>{message}</div>
        </div>
        <div className={classes.buttons}>
          <button type="button" className={cn(classes.buttons, 'close')} onClick={onClose}>Сancel</button>
          <button type="button" className={cn(classes.buttons, 'confirm')} onClick={onConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 10,
    opacity: 0,
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(124, 124, 124, 0.25)',
    transition: '300ms opacity ease',
    pointerEvents: 'none',
  },
  panel: {
    '&': {
      display: 'flex',
      flexDirection: 'column',
      background: 'rgba(255, 255, 255, 1)', // #fcf7f4
      padding: '2.4rem 2.4rem 0',
      boxSizing: 'border-box',
      width: '28rem',
      boxShadow: '0 0 3rem rgba(0, 0, 0, 0.10)',
      borderRadius: '1.4rem',
      paddingBottom: '2.2rem',
      // backdropFilter: 'blur(4px)',
    },
  },
  isShown: {
    opacity: 1,
    pointerEvents: 'all',
  },
  header: {
    '&': {
      position: 'relative',
    },
    '& div': {
      color: '#4A4A4A', // #39C4BD
      fontSize: '2rem',
      fontWeight: 700,
      textAlign: 'center',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  message: {
    fontSize: '1.6rem',
    textAlign: 'center',
    paddingTop: '2rem',
    lineHeight: 1.2,
  },
  buttons: {
    '&': {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingTop: '3.4rem',
    },
    '& > .confirm': {
      backgroundColor: '#57cbc0',
    },
    '& > .close': {
      backgroundColor: '#c5c5c5',
    },
    '& > .confirm, & > .close': {
      color: '#fff',
      border: '0',
      fontSize: '1.6rem',
      fontWeight: '700',
      justifyContent: 'center',
      width: '45%',
      outline: 'none',
      cursor: 'pointer',
      borderRadius: '4.8rem',
      display: 'flex',
      alignItems: 'center',
      /* padding: '1.4rem 0, */
      lineHeight: '3.8rem',
      padding: '0 3rem',
      whiteSpace: 'nowrap',
    },
  },
});

export default memo(ModalConfirmation);
